/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zoom_ControlsInputs */



/**
* | output |
* | --- |
* | "Zoom controls" |
*
* @param {Zoom_ControlsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const zoom_controls = /** @type {((inputs?: Zoom_ControlsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zoom_ControlsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Commandes de zoom")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zoom-Steuerung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controlli dello zoom")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Элементы управления масштабированием")
	if (locale === "es") return /** @type {LocalizedString} */ ("Controles de zoom")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("缩放控制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ズームコントロール")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ज़ूम नियंत्रण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("controles de zoom")
	return /** @type {LocalizedString} */ ("Zoom controls")
});